/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment'
import 'moment/locale/pt';

import ReactExport from "react-export-excel";
import FilterModal from "./components/filterModal"

import FixedContainer from '../../../components/Container';
import { Box, Button, Modal, Typography, TextField, FormControl } from '@mui/material';
import LoadingComponent from '../../../components/LoadingComponent';
import PaginationRounded from '../../../components/NewPagination';
import CustomizedTables from '../../../components/Table';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { GetFetch } from '../../../services/apiBase';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Historic = ({ history }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [filter, setFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const [filterValues, setFilterValues] = useState('');
  const [query, setQuery] = useState('');
  const [cprsPaginate, setCprsPaginate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterStatus, setFilterStatus] = useState('')
  const [filterPersonne, setFilterPersonne] = useState('')
  const [filterCpr, setFilterCpr] = useState('')
  
  const limit = 50;

  const navigate = useNavigate()

  const COLUMNSTABLE = [
    {
      headerName: 'Identificação do investidor',
      type: 'default',
      value: {
        first: {
          value: 'name'
        },
        second: {
          value: 'nova_futura_id'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Número da CPR',
      type: 'default',
      value: {
        first: {
          value: 'cpr_number'
        }
      }
    },
    {
      headerName: 'Data de geração',
      type: 'date',
      value: {
        first: {
          value: 'date_start'
        }
      }
    },
    {
      headerName: 'Data de ativação',
      type: 'date',
      value: {
        first: {
          value: 'date_signed'
        }
      }
    },
    {
      headerName: 'Data final',
      type: 'date',
      value: {
        first: {
          value: 'date_end'
        }
      }
    },
    {
      headerName: 'Valor investido',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr'
        }
      }
    },
    {
      headerName: 'Taxa',
      type: 'percent',
      value: {
        first: {
          value: 'rate_cpr'
        }
      }
    },
    {
      headerName: 'Bois alocados',
      type: 'default',
      value: {
        first: {
          value: 'farmhouseName'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status'
        }
      }
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      }
    },
  ]

  function handleQuery(word) {
    console.log(word)
    if (word.length >= 3) {
      setQuery(word)
      setCurrentPage(1)
    } else {
      setQuery('')
    }
  }

  const handleOpenDetails = (cpr) => {
    return navigate('/cprf/details', { state: { cpr: cpr } })
  }

  const handleOpen = () => {
    setOpen(true)
    setFilter(false)
  }
  const handleClose = () => setOpen(false);

  const handleClearFilter = () => {
    setFilter(false);
    setFilterStatus('')
    setFilterPersonne('');
    setFilterCpr('');
  }

  const getCprPaginations = async () => {
    setLoading(true)
    try {

      const { data } = await GetFetch(`/financial/listCprPaginated?page=${currentPage}&limit=${limit}&status=${filterStatus}&personne=${filterPersonne}&cpr=${filterCpr}&name=${query}`);

      setTotalPages(data.lastPage)
      setCprsPaginate(data.data);

      setError(false)

      if (data.total < 1) {
        enqueueSnackbar('Não existem CPRs com o filtro escolhido!', { variant: 'error' });
      }

    } catch (error) {
      console.log(error);
      setError(true)
      enqueueSnackbar('Ocorreu um erro ao carregar as CPRs!', { variant: 'error' });
    } finally {
      setLoading(false)
    }
  }

  const tableComponent = () => {
    return (
      <Box>
        {cprsPaginate.length > 0
          ? 
          <>
            <CustomizedTables
              data={cprsPaginate}
              columns={COLUMNSTABLE}
              options
              action={handleOpenDetails}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              paddingTop: 2
            }}>
              <PaginationRounded count={totalPages} page={currentPage} handleChange={setCurrentPage} />
            </Box>
          </>
          :
          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            margin: 3
          }}>
            <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
              Não foram encontradas CPRFs
            </Typography>
          </Box>
        }
      </Box>
    )
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar as CPRF's resgatadas
        </Typography>
      </Box>
    )
  }

  const exportExcelComponent = () => {
    return (
      <ExcelFile element={
        <Button variant="contained">Exportar para Excel</Button>
      } filename="cpr_historico">
        <ExcelSheet data={cprsPaginate} name="cpr_historico">
          <ExcelColumn label="Identificação_do_investidor" value={(col) => col.name ? col.name : (col.nova_futura_id ? 'MIGRAÇÃO NOVA FUTURA #' + col.nova_futura_id : "Não informado")} />
          <ExcelColumn label="Número_da_CPR" value="cpr_number" />
          <ExcelColumn label="Data_de_início" value={(col) => moment.utc(col.date_start).format('L')} />
          <ExcelColumn label="Data_final" value={(col) => moment.utc(col.date_end).format('L')} />
          <ExcelColumn label="Valor_investido" value={(col) => col.amount_cpr + ' ' + col.currency} />
          <ExcelColumn label="Taxa" value='rate_cpr' />
          <ExcelColumn label="Bois alocados" value={(col) => col.farmhouseName ? col.farmhouseName : "Não informado"} />
          <ExcelColumn label="Status" value='status' />
          <ExcelColumn label="Tipo" value='type' />
        </ExcelSheet>
      </ExcelFile>
    )
  }

  useEffect(() => {
    getCprPaginations()
  }, [
    currentPage,
    filterStatus,
    filterPersonne,
    filterCpr,
    query
  ]);

  useEffect(() => {
    console.log('FILTER: ', filterStatus)
  }, [filterStatus]);

  moment.locale('pt')
  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
            CPRF's/Historico
          </Typography>

          <Box sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 1,
            marginTop: 1,
          }}>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{
              width: '100%',
              maxWidth: '70%',
            }}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  label="Buscar por investidor"
                  variant="outlined"
                  defaultValue=''
                  onChange={event => handleQuery(event.target.value)} />
              </FormControl>
            </Box>
              
            <Box>
              {filter ?
                <Button variant="contained" sx={{ marginRight: 2}} color="error" onClick={handleClearFilter}>Limpar filtros</Button>
                :
                <Button variant="contained" sx={{ marginRight: 2 }} onClick={handleOpen}>Filtros</Button>
              }
              {exportExcelComponent()}
            </Box>
          </Box>
          {loading ? <LoadingComponent /> :
            error ? errorMessage() :
            cprsPaginate.length < 0 ? 
              <Box sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
              }}>
                <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                  No momento não há CPRS no histórico
                </Typography>
              </Box>
              :
              <>
                {tableComponent()}
              </>
          }
        </Box>
      </FixedContainer>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <FilterModal
          setFilter={setFilter}
          onClose={handleClose}
          setFilterStatus={setFilterStatus}
          setFilterPersonne={setFilterPersonne}
          setFilterCpr={setFilterCpr}
        />
      </Modal>
    </>
  );
}

export default Historic;
